// Fills {apyRate} placeholders in content strings.
// Without a rate, "up to {apyRate}%* APY" becomes "APY*" so no number is shown.
export function fillAPYRate(text: string, apyRate: string | null): string {
  if (apyRate) {
    return text.replace(/{apyRate}/g, apyRate);
  }
  return text.replace(/up to \{apyRate\}%(\*?) APY/g, "APY$1");
}
